import {Component, Input, Output} from '@angular/core';
import {MatTooltipModule} from '@angular/material/tooltip';
import {Subject} from 'rxjs';
import {LoaderService} from '../../../services/sp-loading/loader.service';
import {NgIf} from '@angular/common';

export enum ImageType {
  DENIED = 'sp-page-img-denied',
  MAINTENANCE = 'sp-page-img-maintenance',
  NOT_FOUND = 'sp-page-img-not-found',
  OUT_OF_ORDER = 'sp-page-img-something-wrong'
}

@Component({
  selector: 'app-sp-page-error',
  templateUrl: './sp-page-error.component.html',
  styleUrls: ['./sp-page-error.component.scss'],
  imports: [
    MatTooltipModule,
    NgIf
  ],
  standalone: true
})
export class SpPageErrorComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() buttonText: string;
  @Input() showActionButton: boolean = true;
  @Output() pageButtonClick: Subject<void> = new Subject();

  protected hostClass: string = '';

  constructor(loader: LoaderService) {
    loader.loadedGlobal();
  }

  onButtonClick() {
    this.pageButtonClick.next();
  }

  @Input() set imageType(value: ImageType) {
    this.hostClass = value.valueOf();
  }
}
